// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"57fa5e7eb90440b47619","293":"a2149fbac15f883bf7e3"}[chunkId] + ".js";
};